import './css/index.css'
import './css/animated.css'
import 'semantic-ui-css/semantic.min.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'

const rootEl = document.getElementById('root')
ReactDOM.render(<App />, rootEl)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()

module.hot.accept(App, () => {
  const NextRootContainer = require(App).default
  ReactDOM.render(<NextRootContainer />, rootEl)
})
